// extracted by mini-css-extract-plugin
export default {"section":"container-scroll_section__HFy1D"};